import React from 'react';
import {
  useGridApiContext,
  useGridSelector,
  useGridRootProps,
  gridPageSelector,
  gridPageSizeSelector,
  gridRowCountSelector,
} from '@mui/x-data-grid-pro';
import { PaginationBar } from '../Vendors/companyTabUi';

/**
 * Custom DataGrid footer that renders the shared PaginationBar (per-page selector
 * left, first / previous / numbered / next / last centered) in place of the
 * default MUI TablePagination, so the Admin grids match the company-profile
 * pagination. Wired to the grid's own pagination state, so server- and
 * client-mode grids both work and each grid keeps its configured
 * `rowsPerPageOptions`.
 */
export default function GridPaginationBar() {
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);
  const perPageOptions = rootProps.rowsPerPageOptions as number[] | undefined;

  return (
    <PaginationBar
      variant="inline"
      count={rowCount}
      page={page + 1}
      pageSize={pageSize}
      perPageOptions={perPageOptions}
      onPage={(p) => apiRef.current.setPage(p - 1)}
      onPageSize={(s) => apiRef.current.setPageSize(s)}
    />
  );
}
